import axios from '@/libs/axios'

const API_BASE_URL = '/ProgramacionAcademica'

export const programacionAcademicaService = {
  // Obtener todas las programaciones académicas
  getAll() {
    return axios.get(API_BASE_URL)
  },

  // Obtener programación académica por ID
  getById(id) {
    return axios.get(`${API_BASE_URL}/${id}`)
  },

  // Crear nueva programación académica
  create(data) {
    return axios.post(API_BASE_URL, data)
  },

  // Actualizar programación académica
  update(id, data) {
    return axios.put(`${API_BASE_URL}/${id}`, data)
  },

  // Eliminar programación académica (soft delete)
  delete(id) {
    return axios.delete(`${API_BASE_URL}/${id}`)
  },

  // Obtener programaciones por período
  getByPeriodo(periodoId) {
    return axios.get(`${API_BASE_URL}/by-periodo/${periodoId}`)
  },

  // Obtener programaciones por carrera
  getByCarrera(carreraId) {
    return axios.get(`${API_BASE_URL}/by-carrera/${carreraId}`)
  }
}

export default programacionAcademicaService
